import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class AstronomerHideout2PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.ASTRONOMER_HIDEOUT2;
}

export default AstronomerHideout2PoiTileEntity;
